import { render, staticRenderFns } from "./HealthIcons.vue?vue&type=template&id=52891f7b&scoped=true&"
import script from "./HealthIcons.vue?vue&type=script&lang=js&"
export * from "./HealthIcons.vue?vue&type=script&lang=js&"
import style0 from "./HealthIcons.vue?vue&type=style&index=0&id=52891f7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52891f7b",
  null
  
)

export default component.exports